import React, { useState, useEffect } from "react";
import MenuBar from "../../components/atoms/menuBar/MenuBar";
import { CONTACT_PATH } from "../../router/Routes";
import "./contact.css";
import { BaseDropdown } from "../../components/atoms/dropdowns/Dropdowns";
import { BaseInput } from "../../components/atoms/inputs/Inputs";
import { BaseTextarea } from "../../components/atoms/textareas/Texareas";
import { BaseButton } from "../../components/atoms/buttons/Buttons";
import { SEDES } from "../../res/sedes";
import WHATSAPP from "../../assets/icons/whatsapp.svg";

const Contact = () => {
  useEffect(() => {
    document.title = "Aglocol | Contacto";
  }, []);

  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);

  const mainAddress = "Calle 17#7-83";
  const email = "adriana@aglocol.com";
  const mainPhone = "314 570 9904";

  const sedesArray = (obj) => {
    let arr = [];
    for (let sede of obj) {
      arr.push(sede.title);
    }
    return arr;
  };

  const messagesTopics = [
    "Necesito información sobre un servicio",
    "Necesito información sobre un producto",
    "Otro",
  ];
  const defaultMessageTopic = "¡Selecciona un tema!";

  const changeOffice = (e) => {
    if (e.target.value === "Sedes") {
      setSelectedOffice(null);
    } else {
      for (let sede of SEDES) {
        if (sede.title === e.target.value) {
          setSelectedOffice(sede);
        }
      }
    }
  };

  const changeTopic = (e) => {
    if (e.target.value === defaultMessageTopic) {
      setSelectedTopic(null);
    } else {
      setSelectedTopic(e.target.value);
    }
  };

  const openWhatsapp = (text = "Hola, necesito información") => {
    const phone = "3145709904";
    window.open(`https://api.whatsapp.com/send?phone=+57${phone}&text=${text}`);
  };

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [message, setMessage] = useState("");

  return (
    <div className="main-container contact-background">
      <MenuBar view={CONTACT_PATH} />
      <div className="view-content">
        <div className="contact-container">
          <div className="contact-title">Hablemos</div>

          <div className="directions-container">
            <div className="contact-text">
              Contacta a nuestra Sede Principal
            </div>

            <div className="office-info">{email}</div>
            <div className="office-info">{mainAddress}</div>
            <div className="office-info">{mainPhone}</div>

            <div className="contact-text">
              O ubica la sede de tu preferencia
            </div>

            <BaseDropdown
              className="sedes-dropdown-container"
              defaultSelected="Sedes"
              values={sedesArray(SEDES)}
              callback={changeOffice}
            />

            {selectedOffice !== null ? (
              <>
                <div className="office-info">{selectedOffice.email}</div>
                <div className="office-info">{selectedOffice.address}</div>
                <div className="office-info">{selectedOffice.phone}</div>
                <div className="office-info">{selectedOffice.phone_aux}</div>
              </>
            ) : null}
          </div>

          <div className="messages-container">
            <div className="message-title">Escribenos</div>

            <div className="contact-input-container">
              <BaseInput
                text="Nombre"
                callback={(e) => setName(e.target.value)}
              />
            </div>
            <div className="contact-input-container">
              <BaseInput
                text="Apellido"
                callback={(e) => setLastName(e.target.value)}
              />
            </div>

            <BaseDropdown
              defaultSelected={defaultMessageTopic}
              values={messagesTopics}
              callback={changeTopic}
            />

            {selectedTopic !== null ? (
              <>
                <div className="contact-textarea-container">
                  <BaseTextarea
                    text="Cuentanos un poco sobre lo que tienes en mente"
                    callback={(e) => setMessage(e.target.value)}
                  />
                </div>
                <div className="contact-button-contaniner">
                  <BaseButton
                    text="Enviar"
                    callback={() =>
                      openWhatsapp(
                        `${name !== "" ? `Hola, mi nombre es ${name}` : ""} ${
                          lastName !== "" ? lastName : ""
                        }. ${selectedTopic}: ${message}`
                      )
                    }
                  />
                </div>
              </>
            ) : null}
          </div>
        </div>
        <div>
          <div
            className="whatsapp-icon-tx"
            style={{ display: "flex", flexDirection: "column", color: "black" }}
          >
            <span>¿Quires saber más de aglocol?</span>
            <div> LLAMANOS {mainPhone}</div>
            <div className="container-sm">
              <img
                className="icons-sm"
                src="https://www.brandinglosangeles.com/wp-content/uploads/Instagram-3.png"
                onClick={() =>
                  window.open("https://www.instagram.com/aglocol/")
                }
                alt="Instagram"
              />
              <img
                className="icons-sm"
                src="https://www.iconninja.com/files/124/441/77/facebook-fb-media-social-icon.svg"
                onClick={() =>
                  window.open(
                    "https://es-la.facebook.com/pages/category/Shopping---Retail/Aglomerados-De-Colombia-1581060635516388/"
                  )
                }
                alt="Facebook"
              />{" "}
            </div>
          </div>
          <img
            className="whatsapp-icon"
            src={WHATSAPP}
            onClick={() => openWhatsapp()}
            alt="whatsapp"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
